import { DropResult } from 'react-beautiful-dnd';

function reorderItems<T>(result: DropResult, items: T[], startingIndex: number = 0): T[] | null {
  if (!result.destination) return null;

  const oldIndex = result.source.index + startingIndex;
  const newIndex = result.destination.index + startingIndex;

  if (newIndex === oldIndex) return null;

  const currentItem = items[oldIndex];

  const withoutOldIndex = [...items.slice(0, oldIndex), ...items.slice(oldIndex + 1)];

  const reordered = [
    ...withoutOldIndex.slice(0, newIndex),
    currentItem,
    ...withoutOldIndex.slice(newIndex),
  ];

  return reordered;
}

export default reorderItems;
